// removed by extract-text-webpack-plugin
module.exports = {"brush":"cAFt82vj8MwgHBV1wZUR6","moving":"_1NYn92sS0gT9XivZZMw9ML","left":"Bh9ob6jikAv4b3mYOayfB","right":"_2Ds12n3wT8eEMKgFqaZGWs"};